import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const ACTIVITY_API_PATH = '/api/activity';

const getLogs = async (page = 1, filters = { period: 'today' }) => {
  const params = { page, ...filters };
  const response = await axios.get(`${API_BASE_URL}${ACTIVITY_API_PATH}`, { params });
  return response.data;
};

const activityLogService = {
  getLogs,
};

export default activityLogService;